import { render, staticRenderFns } from "./menu-leaf.vue?vue&type=template&id=6a468475&scoped=true"
import script from "./menu-leaf.vue?vue&type=script&lang=js"
export * from "./menu-leaf.vue?vue&type=script&lang=js"
import style0 from "./menu-leaf.vue?vue&type=style&index=0&id=6a468475&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a468475",
  null
  
)

export default component.exports